// _components/ItemNameField.tsx
import { Input } from '@/app/common/components/input/Input'
import Label from '@/app/common/components/Label'

interface ItemNameFieldProps {
  onChange: React.ChangeEventHandler<HTMLInputElement>
  onBlur: React.FocusEventHandler<HTMLInputElement>
  error: string | undefined
  value: string
}

export function ItemNameField({
  onChange,
  onBlur,
  error,
  value,
}: ItemNameFieldProps) {
  return (
    <div>
      <Label htmlFor="name">Item Name</Label>
      <Input
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        id="name"
        placeholder="Enter item name"
      />
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  )
}
